import { getPDDomain } from "./lib/get-pd-domain.js";
import { getAllCookies } from "./lib/cookies";
import { copyAndMapObj } from "./helpers";
import { setCommissionJunctionCookies } from "./commission-junction";

//jQuery cookie setter with conditional to not write if there is nothing in the query string
var value = getParameterByName("pca");
if (value) {
  //expiration 90 days
  var date = new Date();
  //num of days
  var d = 90;
  date.setTime(date.getTime() + d * 86400000);
  $.cookie("pca", value, { expires: date });
}
//end SALESFORCE TRACKING SCRIPT

// # referer.js contains all important URL parameter-related biz data
// ## UTM tracking
var COOKIE_DOMAIN = getPDDomain();
var IGNORE_DOMAIN = "www.pagerduty.com";

//start SALESFORCE TRACKING SCRIPT
function getParameterByName(name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License
function parseUri(str) {
  var options = {
    strictMode: false,
    key: [
      "source",
      "protocol",
      "authority",
      "userInfo",
      "user",
      "password",
      "host",
      "port",
      "relative",
      "path",
      "directory",
      "file",
      "query",
      "anchor",
    ],
    q: {
      name: "queryKey",
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
    },
    parser: {
      strict:
        /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose:
        /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    },
  };
  var o = options,
    m = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
    uri = {},
    i = 14;

  while (i--) uri[o.key[i]] = m[i] || "";

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function (_$0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });

  return uri;
}

function extractUtmTags(str) {
  var utmValues = {};
  var queryValues = parseUri(str)["queryKey"];
  var keys = Object.keys(queryValues);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key.match(/^utm_/)) {
      utmValues[key] = queryValues[key];
    }
  }
  return utmValues;
}

function setUtmCookies(prefix, cookie_name) {
  //IF the prefix is ft_, and the ft was already set with no Utm Tags in the query string.
  //check if pd_first_page cookie exists.
  //if it does, do not overwrite it. but set it with the current value for another 2 years

  try {
    var utmString = unescape(readCookie(cookie_name));

    //creates an object of all utm_ keys and values
    var utmTags = extractUtmTags(utmString);
    //creates an array of key value pairs for utm_
    var keys = Object.keys(utmTags);

    //If pd_first_page cookie is set, then the user has been on the site before. So check for utm params and set accordingly
    if (cookie_name === "pd_first_page" && keys.length === 0) {
      createCookie(prefix + "_utm_campaign", "_none_", 365 * 2);
      createCookie(prefix + "_utm_medium", "_none_", 365 * 2);
      createCookie(prefix + "_utm_content", "_none_", 365 * 2);
      createCookie(prefix + "_utm_source", "_none_", 365 * 2);
      createCookie(prefix + "_utm_term", "_none_", 365 * 2);
    } else {
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        createCookie(prefix + "_" + key, utmTags[key], 365 * 2);
      }
    }

    if (cookie_name === "pd_last_page") {
      //Check if first visit
      if (!readCookie("pd_first_visit")) {
        //if first visit ever, reset all utms to _none_ and then override them if present
        createCookie(prefix + "_utm_campaign", "_none_", 365 * 2);
        createCookie(prefix + "_utm_medium", "_none_", 365 * 2);
        createCookie(prefix + "_utm_content", "_none_", 365 * 2);
        createCookie(prefix + "_utm_source", "_none_", 365 * 2);
        createCookie(prefix + "_utm_term", "_none_", 365 * 2);
      }
      if (keys.length > 0) {
        createCookie(prefix + "_utm_campaign", "_none_", 365 * 2);
        createCookie(prefix + "_utm_medium", "_none_", 365 * 2);
        createCookie(prefix + "_utm_content", "_none_", 365 * 2);
        createCookie(prefix + "_utm_source", "_none_", 365 * 2);
        createCookie(prefix + "_utm_term", "_none_", 365 * 2);

        for (i = 0; i < keys.length; i++) {
          key = keys[i];
          createCookie(prefix + "_" + key, utmTags[key], 365 * 2);
        }
      }
    }
  } catch (err) {
    console.error("err" + err);
  }
}

function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }

  document.cookie =
    name + "=" + value + expires + "; path=/; domain=" + COOKIE_DOMAIN;
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function stringContains(str1, str2) {
  return str1.indexOf(str2) > -1;
}

function cleanHref(ref) {
  return encodeURIComponent(ref).replace("(", "%28").replace(")", "%29");
}

function getHostname(url) {
  if (url === "_none_") return url;
  var u = parseUri(url);
  return u.host;
}

function setReferrer(field, testHref) {
  var ref = document.referrer ? document.referrer : "_none_";

  if (testHref && !testHref(ref)) return;
  createCookie(field, cleanHref(ref), 365 * 2);
  if (field === "pd_referrer") {
    createCookie("pd_ft_referrer", getHostname(ref), 365 * 2);
  }
}

function setPage(field) {
  var ref = document.location.href;
  createCookie(field, cleanHref(ref), 365 * 2);
}

function setVisit(field) {
  createCookie(field, Math.round(+new Date() / 1000), 365 * 2);
}

// GCLID
// https://support.google.com/adwords/answer/2998031
// JIRA ticket #IT-940; added by D.Rau May 5, 2015
function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = "; expires=" + date.toGMTString();
  document.cookie =
    name + "=" + value + expires + "; path=/; domain=" + COOKIE_DOMAIN;
}
function getParam(p) {
  var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

/** @type {Readonly<Object<string, string>>} */
const UTM_REST_KEYS = {
  ft_utm_campaign: "ft_utm_campaign__c",
  ft_utm_content: "ft_utm_content__c",
  ft_utm_medium: "ft_utm_medium__c",
  ft_utm_source: "ft_utm_source__c",
  ft_utm_term: "ft_utm_term__c",
  lt_utm_campaign: "lt_utm_campaign__c",
  lt_utm_content: "lt_utm_content__c",
  lt_utm_medium: "lt_utm_medium__c",
  lt_utm_source: "lt_utm_source__c",
  lt_utm_term: "lt_utm_term__c",

  gclid: "gclid__c",
  mkwid: "Mkwid__c",
};

/**
 * Make a sign-up object from formData
 * @arg {Object} fields
 * @return {Object}
 */
function mapUTMToHiddenFields(fields) {
  return copyAndMapObj(UTM_REST_KEYS, fields, {});
}

/**
 * @param {{ [x: string]: any; }} fields
 */
function buildUTMHiddenFields(fields) {
  const mktoForm = document.getElementById("mkto-api-form");
  for (const field in fields) {
    let input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", `${field}`);
    input.setAttribute("value", `${fields[field]}`);
    if (mktoForm) mktoForm.appendChild(input);
  }
}

function loadUTMFields() {
  const cookies = getAllCookies();
  let utmFields = {};
  if (cookies) {
    for (const property in cookies) {
      const regex = /ft_utm_*|lt_utm_*|mkwid|gclid/g;
      const found = property.match(regex);
      if (found) {
        utmFields[property] = cookies[property];
      }
    }

    utmFields = mapUTMToHiddenFields(utmFields);
    buildUTMHiddenFields(utmFields);
  }
}

export function loadPDTracking() {
  if (!readCookie("pd_referrer")) {
    setReferrer("pd_referrer");
  }
  if (!readCookie("pd_last_referrer")) {
    setReferrer("pd_last_referrer", function (href) {
      return !stringContains(href.toLowerCase(), IGNORE_DOMAIN);
    });
  }

  //This calls set page only once per session
  if (!readCookie("pd_first_page")) {
    setPage("pd_first_page");
  }
  //This calls set page on every page load
  setPage("pd_last_page");

  //IMPORTANT - These need to be set before calling setVisit();
  setUtmCookies("ft", "pd_first_page");
  setUtmCookies("lt", "pd_last_page");
  if (!readCookie("pd_first_visit")) {
    setVisit("pd_first_visit");
  }
  setVisit("pd_last_visit");

  var gclid = getParam("gclid");
  if (gclid) {
    var gclsrc = getParam("gclsrc");
    if (!gclsrc || gclsrc.indexOf("aw") !== -1) {
      setCookie("gclid", gclid, 90);
    }
  }
  var mkwid = getParam("mkwid");
  if (mkwid) {
    setCookie("mkwid", mkwid, 90);
  }

  loadUTMFields();
  setCommissionJunctionCookies();
}
